import { NgModule } from '@angular/core';

import { MainComponent } from './main.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";

const routes: Routes = [
    {
        "path": "",
        "component": MainComponent,
        "canActivate": [AuthGuard],
        "children": [
            {
                "path": "disbursed",
                "loadChildren": ".\/pages\/default\/inner\/inner.module#InnerModule"
            },
            {
                "path": "404",
                "loadChildren": ".\/pages\/default\/not-found\/not-found.module#NotFoundModule"
            },
            {
                "path": "portfolio",
                "loadChildren": ".\/pages\/default\/profile-dashboard\/profile-dashboard.module#ProfileDashboardModule"
            },
            {
                "path": "admin",
                "loadChildren": ".\/pages\/default\/user\/user.module#UserModule"
            },
            {
                "path": "resetpassword",
                "loadChildren": ".\/pages\/default\/reset-password\/reset-password.module#ResetPasswordModule"
            },
            {
                "path": "deposit",
                "loadChildren": ".\/pages\/default\/deposit-dashboard\/deposit-dashboard.module#DepositDashboardModule"
            },
            {
                "path": "finance",
                "loadChildren": ".\/pages\/default\/finance-dashboard\/finance-dashboard.module#FinanceDashboardModule"
            },
            {
                "path": "",
                "redirectTo": "portfolio",
                "pathMatch": "full"
            }
        ]
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MainRoutingModule { }


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/main/main-routing.module.ts